var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "elc-card",
                  attrs: {
                    color: "blue-grey",
                    dark: "",
                    fixed: "",
                    app: "",
                    "clipped-right": ""
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "elc-header-icon",
                      on: {
                        click: function($event) {
                          _vm.sideNav = !_vm.sideNav
                        }
                      }
                    },
                    [_vm._v("menu")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { cursor: "pointer !important" },
                      on: { click: _vm.goToOverview }
                    },
                    [_c("h1", [_vm._v("ELECTORAL LITERACY CLUB")])]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("div", { staticClass: "elc-announcement" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/assets/image/announcementHeader.png"),
                        title: "Announcement"
                      },
                      on: {
                        click: function($event) {
                          _vm.openAnnouncementDelDialog()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { staticClass: "p-20", attrs: { bottom: "" } },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticStyle: {
                            color: "#515a75",
                            "font-weight": "bold",
                            "font-size": "20px",
                            "background-color": "#fff"
                          },
                          attrs: { slot: "activator", size: "36px" },
                          slot: "activator"
                        },
                        [_c("span", [_vm._v("  " + _vm._s(_vm.loginUser[0]))])]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(" " + _vm._s(_vm.loginUser))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "text-sm-center",
                          attrs: { slot: "activator", icon: "" },
                          on: { click: _vm.openDialog },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("settings_power")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Logout")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "elc-side-menu",
          attrs: { absolute: "", clipped: "", temporary: "", app: "" },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
            }
          },
          model: {
            value: _vm.sideNav,
            callback: function($$v) {
              _vm.sideNav = $$v
            },
            expression: "sideNav"
          }
        },
        [
          _vm.user.officer_role == 0
            ? _c(
                "v-list",
                [
                  _c(
                    "v-list-tile",
                    {
                      staticClass: "elc-box-list",
                      attrs: { to: "/myclubs/district/taluka/club" }
                    },
                    [
                      _c("span", { staticClass: "elc-lable" }, [
                        _vm._v("My Clubs ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    {
                      staticClass: "elc-box-list",
                      attrs: { to: "/knowledgebase" }
                    },
                    [
                      _c("span", { staticClass: "elc-lable" }, [
                        _vm._v("Knowledge Base")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    { staticClass: "elc-box-list", attrs: { to: "/settings" } },
                    [
                      _c("span", { staticClass: "elc-lable" }, [
                        _vm._v("Settings")
                      ])
                    ]
                  )
                ],
                1
              )
            : _c(
                "v-list",
                [
                  _vm._l(_vm.menuItems1, function(menu, index) {
                    return _c(
                      "v-list-tile",
                      {
                        key: index,
                        staticClass: "elc-box-list",
                        attrs: { to: menu.path }
                      },
                      [
                        _c("span", { staticClass: "elc-lable" }, [
                          _vm._v(_vm._s(menu.title) + " ")
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-list-group",
                    [
                      _c(
                        "v-list-tile",
                        { attrs: { slot: "activator" }, slot: "activator" },
                        [
                          _c("span", { staticClass: "elc-lable1" }, [
                            _vm._v("ELC Clubs")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.user.officer_role !== 5
                        ? _c(
                            "v-list-tile",
                            {
                              staticClass: "elc-box-list",
                              attrs: { to: "/myclubs/district/taluka/club" }
                            },
                            [
                              _c("span", { staticClass: "elc-lable p-l-32" }, [
                                _vm._v("My Clubs")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        {
                          staticClass: "elc-box-list",
                          attrs: { to: "/clubs/district/taluka/club" }
                        },
                        [
                          _c("span", { staticClass: "elc-lable p-l-32" }, [
                            _vm._v("All Clubs")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    {
                      staticClass: "elc-box-list",
                      attrs: { to: "/knowledgebase" }
                    },
                    [
                      _c("span", { staticClass: "elc-lable" }, [
                        _vm._v("Knowledge Base")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    { staticClass: "elc-box-list", attrs: { to: "/settings" } },
                    [
                      _c("span", { staticClass: "elc-lable" }, [
                        _vm._v("Settings")
                      ])
                    ]
                  )
                ],
                2
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.confirmDialog,
            callback: function($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [_vm._v("Are you sure, you want to logout ?")]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.confirmDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.logout($event)
                        }
                      }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "400px",
            "max-height": "600px"
          },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              return _vm.cancelAnnoucementDialog($event)
            }
          },
          model: {
            value: _vm.announcementDialog,
            callback: function($$v) {
              _vm.announcementDialog = $$v
            },
            expression: "announcementDialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "formAN",
              staticStyle: { "text-transform": "capitalize" },
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { float: "right !important" },
                          attrs: { slot: "activator", icon: "" },
                          on: { click: _vm.cancelAnnoucementDialog },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("clear")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Close")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "p-10" },
                    [
                      _c("v-card-title", { staticClass: "p-0 p-l-10" }, [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v("Announcement ")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { staticClass: "p-10", attrs: { "grid-list-md": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _vm.announcementDialog
                                        ? _c("v-text-field", {
                                            attrs: {
                                              autofocus: "",
                                              name: "title",
                                              label: "Title",
                                              rules: _vm.fieldRules
                                            },
                                            model: {
                                              value: _vm.title,
                                              callback: function($$v) {
                                                _vm.title = $$v
                                              },
                                              expression: "title"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      name: "description",
                                      label: "Description"
                                    },
                                    model: {
                                      value: _vm.description,
                                      callback: function($$v) {
                                        _vm.description = $$v
                                      },
                                      expression: "description"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius",
                          attrs: { flat: "" },
                          on: { click: _vm.cancelAnnoucementDialog }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius-color",
                          attrs: { flat: "", disabled: _vm.title == "" },
                          on: { click: _vm.addAnnoucement }
                        },
                        [_vm._v("Save\n                    ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd815696", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd815696","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/ElcHeader.vue
// module id = null
// module chunks = 